angular.module('components.caOrderScannerNavigation', [])
    .component('caOrderScannerNavigation', {
        templateUrl: 'main/order/orderdelivery/components/orderscannernavigation.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderChangeCount: '<',
            order: '<',
            onArticleSelected: '&',
            deliverOrder: '&'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    var deliverWholeOrderCode = "444e45";

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.navigationScannerInput = "";

    vm.scanInputKeyPress = scanInputKeyPress;

    function onInit() {
        focusScanningInputField();
    }
    function onChanges() {

    }
    function onDestroy() {

    }

    function focusScanningInputField() {
        var scanField = angular.element("#navScanInput");
        scanField.focus();
    }

    function scanInputKeyPress(ev) {
        var enterKeyCode = 13;
        if (ev !== undefined && ev.keyCode === enterKeyCode) {
            processNavigationScannerInput(vm.navigationScannerInput);
        }
    }

    function processNavigationScannerInput(input) {
        // Determine whether the scanned code is a command or just a lookup
        switch (input) {
            case deliverWholeOrderCode:
                console.log("Delivering whole order");
                vm.deliverOrder();
                break;
            default:

                var orderArticle = _.find(vm.order.orderArticles, function(ordArt) {
                    var alternativeArticleNumber = ordArt.article.alternativeArticleNumber;
                    alternativeArticleNumber = alternativeArticleNumber.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
                    return alternativeArticleNumber === input;
                });
                if (orderArticle !== undefined) {
                    vm.onArticleSelected({article: orderArticle.article});
                } else {
                    console.log("Unknown");
                }
                break;
        }

        vm.navigationScannerInput = "";
    }
}
